import setupStore from 'Application/store/setupStore';

const { store, persistor, history } = setupStore();

export { store, persistor, history };
